// extracted by mini-css-extract-plugin
export default {"root":"Fortune500BoardMemberBadge_root__W5ld2"};